import { useContext } from "preact/hooks";
import { ArtworkContext } from "../context/artwork-context";

export const useArtwork = () => {
    const context = useContext(ArtworkContext);
    if (!context) {
      throw new Error('useArwork must be used within an ArtworkProvider');
    }
    return context;
  };
